export const getNestedProperty = (item: any, path: string) =>
  path?.split('.')?.reduce((obj, key) => obj?.[key] ?? null, item);
